import modal from './modal.js';

const chat = {
    launchChatWindow: function () {
        if (document.querySelector('.f9ChatOpened')) {
            return;
        }

        if (window.FIVN?.open) {
            window.FIVN.open();
            return;
        }

        this._showNotAvailableModal();
    },
    _showNotAvailableModal: function () {
        const div = document.createElement('div');

        div.innerHTML =
            "Thanks for reaching out to SmartPak! We're not available to chat right now, so please call us at <span class='hideOnMobile'>1-800-461-8898</span><span class='showOnMobile'><a href='tel:1-800-461-8898'>1-800-461-8898</a></span> for immediate assistance.  Have a great ride!";

        modal(div, {
            title: 'Chat',
            removeContents: true
        });
    },
    init: function () {
        document.addEventListener('click', e => {
            if (e.target.classList.contains('chatZone')) {
                e.preventDefault();
                this.launchChatWindow();
            }
        });
    }
};

export default chat;